import { Logo } from '@/components/logo';
import { ROUTES } from '@/types/routes';
import { Col, Divider, Flex, Grid, Row, Typography } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import './Footer.scss';
import { UserRole } from '@/types';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectUser } from '@/slice/user';
import CopyRight from './CopyRight';

const Footer: FC = () => {
  const { lg } = Grid.useBreakpoint();
  const { role } = useAppSelector(selectUser);

  // TCX-668: link straight to the audience-specific, dynamically-published Terms
  // of Use page. (The legacy /terms-and-conditions route now just redirects to
  // these canonical pages, so pointing here skips the extra redirect hop.) Role
  // is always known in this authenticated footer; default to consultant if not.
  const termsRoute =
    role === UserRole.FRANCHISEE
      ? ROUTES.TERMS_OF_USE_FRANCHISOR
      : ROUTES.TERMS_OF_USE_CONSULTANT;

  const getNavigation = (role: UserRole | undefined) => {
    if (!role) return;

    const navigation: Partial<
      Record<UserRole, { label: string; path: ROUTES }[]>
    > = {
      franchisor: [
        { label: 'Find Consultants', path: ROUTES.FIND_CONSULTANT },
        { label: 'My Meetings', path: ROUTES.MY_BOOKINGS },
        { label: 'Payments', path: ROUTES.PAYMENTS },
      ],
      consultant: [
        { label: 'Find Franchisors', path: ROUTES.FIND_FRANCHISORS },
        { label: 'My Meetings', path: ROUTES.MY_BOOKINGS },
        { label: 'Payments', path: ROUTES.PAYMENTS },
      ],
    };

    return navigation[role];
  };

  return (
    <Row className={'default-footer'}>
      <Col span={24}>
        <Flex gap={lg ? 0 : 32} wrap justify={'space-between'}>
          <Logo />

          <Flex wrap gap={lg ? 68 : '24px 41px'}>
            {getNavigation(role)?.map((item) => (
              <Link
                className={'navigation-link'}
                key={item.path}
                to={item.path}
              >
                {item.label}
              </Link>
            ))}
          </Flex>
        </Flex>
      </Col>

      <Divider />

      <Col span={24}>
        <Flex gap={lg ? 0 : 16} wrap justify={'space-between'}>
          <CopyRight className={'text'} />
          <Flex wrap gap={lg ? 8 : 16}>
            <Link
              className={'text'}
              to={termsRoute}
              target={'_blank'}
              rel={'noreferrer'}
            >
              Terms and Conditions
            </Link>

            <Link
              className={'text'}
              to={ROUTES.PRIVACY_AND_POLICY}
              target={'_blank'}
              rel={'noreferrer'}
            >
              Privacy Policy
            </Link>
          </Flex>
        </Flex>
      </Col>
    </Row>
  );
};

export { Footer };
